export const enableMocking = async () => {
  if (import.meta.env.VITE_ADMIN_MOCKING === 'true') {
    const { worker } = await import('./browser');
    const { initializeDb } = await import('./db');
    initializeDb();
    await worker.start();
  }
  return Promise.resolve();
};
